import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Linda M.',
    age: '58',
    state: 'Texas',
    quote: 'At some point I started sleeping in the guest room because it just felt easier. The first night after my husband used SnoreStop™ I woke up confused because I realized I had actually slept through the night next to him again.'
  }, {
    name: 'Karen D.',
    age: '62',
    state: 'Florida',
    quote: 'I ordered it without telling him because honestly I did not think another product would work. Within the first week I noticed the nights were quieter and we both seemed less exhausted during the day.'
  }, {
    name: 'Michelle R.',
    age: '51',
    state: 'Ohio',
    quote: 'The mornings were always the worst part. He would apologize and I would pretend it was fine. Better sleep completely changed the mood in our house.'
  }, {
    name: 'Susan T.',
    age: '66',
    state: 'Arizona',
    quote: 'My husband refused CPAP because he hated how it made him feel. This was the first thing he actually stuck with because it was simple and comfortable.'
  }];
  return <section className="py-24 bg-white" data-id="element-342">
      <Container data-id="element-343">
        <div className="text-center mb-16" data-id="element-344">
          <h2 className="text-sm font-bold tracking-widest text-gray-400 uppercase mb-4" data-id="element-345">
            Real Customer Stories
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-346">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-[#FDFBF7] p-8 rounded-2xl border border-gray-100" data-id="element-347">
              <div className="flex text-orange-400 mb-4" data-id="element-348">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-current" data-id="element-349" />)}
              </div>
              <p className="text-gray-700 text-lg leading-relaxed mb-6 italic" data-id="element-350">
                "{t.quote}"
              </p>
              <div className="text-sm font-medium text-gray-900" data-id="element-351">
                {t.name} • {t.age} • {t.state}
              </div>
            </motion.div>)}
        </div>
      </Container>
    </section>;
}